import styled from "styled-components";
import Modal from "react-modal";
import Button from "../Buttons";
import { Colors } from "../../ColorConstants";
import { Text } from "../../TextConstants";
import { FreeTicket } from "../../assets/images";

const CartModal = ({
  isCancelTicket,
  closeTicketModal,
  navigate,
  insertId,
}) => {
  return (
    <Modal
      isOpen={isCancelTicket}
      onRequestClose={closeTicketModal}
      contentLabel="Modal confirmation"
      style={{
        content: {
          height: "24rem",
          width: "17rem",
          display: "grid",
          gridTemplateRows: "1fr 1fr 1fr 1fr",
          gridTemplateColumns: "1fr",
          justifyContent: "center",
          padding: 0,
          background: "transparent",
          border: "none",
          position: "unset",
        },
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
      }}
    >
      <ImageContainer>
        <FreeTicketImg src={FreeTicket} />
      </ImageContainer>
      <SubContainer>
        <MainText>{Text.congratulations}</MainText>
        <DetailText>{Text.complementaryText}</DetailText>
        <ButtonContainer>
          <Button
            label="Done"
            variant="filled"
            padding="0.5rem 1.25rem"
            width="100%"
            onClick={() => navigate(`/app/success?insertId=${insertId}`)}
          />
        </ButtonContainer>
      </SubContainer>
    </Modal>
  );
};

export default CartModal;

const ImageContainer = styled.div`
  display: flex;
  grid-column: 1/-1;
  grid-row: 1/3;
  position: relative;
  display: flex;
  justify-content: center;
`;
const SubContainer = styled.div`
  background: rgba(231, 231, 231, 1);
  grid-column: 1/-1;
  grid-row: 2/5;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-bottom: 1rem;
  justify-content: flex-end;
  border-radius: 8px;
`;
const MainText = styled.span`
  color: ${Colors.aqua};
  text-align: center;
  font-size: 1.5rem;
  font-weight: 700;
`;
const DetailText = styled.span`
  color: ${Colors.black};
  text-align: center;
  font-size: 1rem;
  font-weight: 400;
  margin-top: 1rem;
`;
const FreeTicketImg = styled.img`
  width: 12rem;
  height: 11rem;
`;

const ButtonContainer = styled.div`
  display: flex;
  margin-top: 1.5rem;
  width: 80%;
  justify-content: space-between;
  @media only screen and (max-width: 414px) {
    margin-top: 1.5rem;
  }
`;
